import React, { useState, useEffect } from "react";
import TruckImage from "../../assets/image/Truck.png";
import BicycleImage from "../../assets/image/Bicycle.png";
import Commercial from "../../assets/image/Mini.png";
import { motion } from "framer-motion";
import * as XLSX from "xlsx";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Del from "../../assets/icons/Del";

import { FaTimes } from "react-icons/fa";
import {
  getAllRequestList,
  searchRequestList,
  getRequestById,
  getCompanyList,
  addComment,
  addQuotation,
  policyUploaded,
  varifyActivityPoint,
  deleteLead,
  updateRequestForPayment,
} from "../../redux/action/request";
import { ToastContainer } from "react-toastify";
import { getUserList } from "../../redux/action/auth";
import { useDispatch, useSelector } from "react-redux";
import DownloadIcon from "../../assets/icons/download";
import { Circles } from "react-loader-spinner";

const Request = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const { allRequestList } = useSelector((state) => state.auth);
  const { userslist } = useSelector((state) => state.auth);
  const { requestById } = useSelector((state) => state.auth);
  const { companyList } = useSelector((state) => state.auth);
  const [policyUpload, setPolicyUpload] = useState(null);
  const [commentId, setCommentId] = useState(null);
  const [quotation, setQuotation] = useState(null);
  const [comment, setComment] = useState("");
  const [uploadPolicy, setUploadPolicy] = useState(null);
  const [policyExpire, setPolicyExpire] = useState(null);
  const [quotationDetail, setQuotationDetail] = useState([
    {
      companyName: "",
      coverAmount: "",
      cashlessCharge: "",
      activityPoints: 0,
      companyLogo: "",
      premiumAmount: "",
      paymentLink: "",
    },
  ]);

  const [visibleTooltipId, setVisibleTooltipId] = useState(null);

  const handleDelete = (id) => {
    // Toggle tooltip for the specific card
    setVisibleTooltipId(visibleTooltipId === id ? null : id);
  };

  const confirmDelete = (id) => {
    dispatch(deleteLead(visibleTooltipId));
    setVisibleTooltipId(null);
    setTimeout(() => dispatch(getAllRequestList()), 4000);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, [1000]);
  const { employee } = useSelector((state) => state.auth);
  const addForm = () => {
    if (quotationDetail.length < 3) {
      setQuotationDetail([
        ...quotationDetail,
        {
          companyName: "",
          coverAmount: "",
          cashlessCharge: "",
          activityPoints: 0,
          companyLogo: "",
          premiumAmount: "",
        },
      ]);
    } else {
      alert("You can only add up to 3 quotations.");
    }
  };

  const uploadRequestPolicy = () => {
    const policyData = {
      policyUploaded: true,
      policyExpire: policyExpire,
      policyUrl: policyUpload,
    };
    dispatch(policyUploaded(uploadPolicy, policyData));
    setUploadPolicy(null);
  };

  // Remove form (if more than 1 form)
  const removeForm = (index) => {
    if (quotationDetail.length > 1) {
      const updatedDetails = quotationDetail.filter((_, i) => i !== index);
      setQuotationDetail(updatedDetails);
    } else {
      alert("You must have at least 1 quotation.");
    }
  };

  // Handle input change for a specific form
  const handleInputChange = (index, field, value) => {
    if (field == "companyName") {
      for (let x = 0; x <= companyList.length; x++) {
        if (companyList[x]?.companyName == value) {
          const updatedDetails = [...quotationDetail];
          updatedDetails[index]["companyLogo"] = companyList[x].companyLogo;
          setQuotationDetail(updatedDetails);
        }
      }
    }

    const updatedDetails = [...quotationDetail];
    updatedDetails[index][field] = value;
    setQuotationDetail(updatedDetails);
  };
  const downloadImage = (url) => {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = "payment_screenshot.png"; // Set the filename
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl); // Free memory
      })
      .catch((error) => console.error("Download failed:", error));
  };

  // Submit functionality (you can replace this with your API call or further logic)
  const handleSubmit = () => {
    const data = { quotationDetail: quotationDetail };
    console.log(data,"*******************")
    setTimeout(() => {
      dispatch(getRequestById(requestById._id));
    }, 2000);
    dispatch(addQuotation(requestById?._id, data));
    setQuotation(null);
  };

  useEffect(() => {
    dispatch(getUserList());
  }, [1000]);

  useEffect(() => {}, [requestById]);
  const [serachPram, setSerachPram] = useState({
    vehicleType: "",
    requestType: "",
    userId: "",
    fuelType: "",
    policyType: "",
    startDate: "",
    endDate: "",
  });
  const onSerach = () => {
    const data = removeEmptyStrings();
    dispatch(searchRequestList(data));
  };

  const removeEmptyStrings = () => {
    const filteredParams = {};
    console.log(serachPram);
    for (const key in serachPram) {
      if (serachPram[key] !== "") {
        filteredParams[key] = serachPram[key];
      }
    }

    return filteredParams;
  };
  useEffect(() => {
    dispatch(getAllRequestList());
    dispatch(getCompanyList());
  }, [1000]);
  const getSpecificRequest = (id) => {
    dispatch(getRequestById(id));
  };

  const handleExport = () => {
    const MAX_CHAR_LIMIT = 32767;

    const findLongValues = (data) => {
      for (const key in data) {
        if (
          typeof data[key] === "string" &&
          data[key].length > MAX_CHAR_LIMIT
        ) {
          console.warn(
            `⚠️ Field "${key}" exceeds ${MAX_CHAR_LIMIT} characters. Length: ${data[key].length}`
          );
        }
        if (typeof data[key] === "object" && data[key] !== null) {
          try {
            const jsonString = JSON.stringify(data[key]);
            if (jsonString.length > MAX_CHAR_LIMIT) {
              console.warn(
                `⚠️ Field "${key}" (Object) exceeds ${MAX_CHAR_LIMIT} characters. Length: ${jsonString.length}`
              );
            }
          } catch (error) {
            console.error(`Error stringifying field "${key}"`, error);
          }
        }
      }
    };
    // Assuming `requestVehicleStat` is the data you want to export, modify it to flatten the nested structure if necessary
    const exportData = allRequestList.map((vehicle) => {
      const data = {
        _id: vehicle._id,
        userId: vehicle.userId,
        vehicleType: vehicle.vehicleType,
        policyType: vehicle.policyType,
        previousPolicyType: vehicle.previousPolicytype,
        previousYearClaim: vehicle.previousYearclame,
        policyExpiryDate: vehicle.policyExpirydate,
        make: vehicle.make,
        vehicleModel: vehicle.vehicleModel,
        GVC: vehicle.GVC,
        registerNumber: vehicle.registerNumber,
        manufactureDate: vehicle.manufactureDate,
        fuelType: vehicle.fuelType,
        paymentVerified: vehicle.paymentVarified,
        requestSent: vehicle.requestSent,
        quotationMade: vehicle.quotationMade,
        paymentDone: vehicle.paymentDone,
        policyUploaded: vehicle.policyUploaded,
        ownerName: vehicle.ownerDetail?.ownerName,
        ownerPhone: vehicle.ownerDetail?.ownerPhone,
        ownerAddress: vehicle.ownerDetail?.ownerAddress,
        ownerEmail: vehicle.ownerDetail?.ownerEmail,
        vehicleDetailURL: vehicle.vehicleDetailURL,
        previousPolicyURL: vehicle.previousPolicyURL,
        ncbOfPreviousPolicy: vehicle.ncbOfPreviousPolicy,
        ODInsurer: vehicle.ODInsurer,
        paymentStatus: vehicle.paymentDetail?.status,
        activityPointsReceived: vehicle.paymentDetail?.activityPointsReceived,
        registerDate: vehicle.registerDate,
        quotationCompanyName: vehicle.quotationDetail[0]?.companyName,
        quotationCoverAmount: vehicle.quotationDetail[0]?.coverAmount,
        quotationPremiumAmount: vehicle.quotationDetail[0]?.premiumAmount,
        quotationActivityPoints: vehicle.quotationDetail[0]?.activityPoints,
        userName: vehicle.userDetails?.name,
        userPhone: vehicle.userDetails?.phone,
        userEmail: vehicle.userDetails?.email,
        userCNIC: vehicle.userDetails?.CNIC,
        userAddress: vehicle.userDetails?.address,
        userProfession: vehicle.userDetails?.profession,
        userType: vehicle.userDetails?.userType,
      };

      // Check for long values before truncating
      // 🛑 DELETE large fields before exporting 🛑
      delete data.vehicleDetailURL; // If this contains large base64 image data
      delete data.previousPolicyURL; // Remove large URLs if not needed

      if (data.paymentDetail) {
        delete data.paymentDetail.largeNestedField; // Remove unnecessary large objects
      }

      // Check for long values before truncating
      findLongValues(data);

      // Convert nested objects/arrays to strings and truncate them
      for (const key in data) {
        if (typeof data[key] === "object" && data[key] !== null) {
          data[key] = JSON.stringify(data[key]); // Convert objects to strings
        }
        if (
          typeof data[key] === "string" &&
          data[key].length > MAX_CHAR_LIMIT
        ) {
          console.warn(
            `Truncating "${key}" as it exceeds ${MAX_CHAR_LIMIT} characters.`
          );
          data[key] = data[key].substring(0, MAX_CHAR_LIMIT) + "..."; // Truncate long strings
        }
      }

      return data;
    });

    try {
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(exportData);
      XLSX.utils.book_append_sheet(wb, ws, "Requests Data");

      // Generate and download the Excel file
      XLSX.writeFile(wb, `requests_list.xlsx`);
    } catch (error) {
      console.error("Excel export error:", error);
    }
  };
  const addRequestComment = () => {
    const commentData = {
      discription: comment,
      requestId: commentId.requestId,
      userId: commentId.userId,
    };
    dispatch(addComment(commentData));
    setCommentId(null);
  };
  const onChangeUpload = async (e) => {
    const file = e.target.files[0]; // Get the selected file

    if (file) {
      try {
        const Base64 = await convertToBase64(file);
        console.log(Base64, "Base64");
        setPolicyUpload(Base64);
      } catch (error) {
        console.error("Error converting to Base64:", error);
      }
    } else {
      console.warn("No file selected!");
    }
  };

  const varifyActivityPoints = () => {
    dispatch(varifyActivityPoint(requestById?._id));
    setTimeout(() => {
      dispatch(getRequestById(requestById?._id));
    }, [1000]);
  };
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        // Resolve with the entire Base64 string, including the prefix
        resolve(reader.result);
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  const goBack = () => {
    dispatch({
      type: "GET_ALL_REQUEST_BYID",
      payload: {}, // Ensure response format matches expectations
    });
  };

  const [isObject, setIsObject] = useState(null);

  const openModal = (data) => setIsObject(data);
  const closeModal = (data) => setIsObject(null);
  return (
    <>
      {!loading ? (
        <>
          <ToastContainer />
          {Object.keys(requestById).length > 0 && (
            <div className="sticky top-5 mt-3 left-5">
              <button
                onClick={goBack}
                className="bg-blue-500 text-white p-2 rounded-full hover:bg-gray-700"
              >
                ← Back
              </button>
            </div>
          )}

          {Object.keys(requestById).length === 0 ? (
            <div className="p-4 bg-gray-100">
              <div className="flex justify-between items-center mb-4">
                <h1 className="text-xl font-bold">Quotation Request</h1>
                <span
                  onClick={() => handleExport()}
                  className="px-4 py-2 bg-[#1E90FE] text-white font-semibold rounded-lg hover:bg-white hover:text-black transition-colors duration-300 ease-in-out cursor-pointer"
                >
                  {" "}
                  Export Excel
                </span>
              </div>

              {/* Filter Section */}
              <div className="grid grid-cols-5 gap-4 mb-2">
                <div className="relative">
                  <select
                    className="border p-2 rounded w-full"
                    value={serachPram?.vehicleType}
                    onChange={(e) =>
                      setSerachPram({
                        ...serachPram,
                        vehicleType: e.target.value,
                      })
                    }
                  >
                    <option value="" disabled selected>
                      Search by Vehicles type
                    </option>
                    <option value="Car">Car</option>
                    <option value="Bike">Bike</option>
                    <option value="Commercial Vehicle">
                      Commercial Vehicle
                    </option>
                  </select>
                </div>

                <select
                  className="border p-2 rounded"
                  value={serachPram?.requestType}
                  onChange={(e) =>
                    setSerachPram({
                      ...serachPram,
                      requestType: e.target.value,
                    })
                  }
                >
                  <option value="" disabled selected>
                    Search by Status
                  </option>
                  <option value="requestSent">Review Pending</option>
                  <option value="quotationMade">Quotation Made</option>
                  <option value="paymentDone">Payment Done</option>
                  <option value="policyUploaded">Policy Uploaded</option>
                </select>

                <select
                  className="border p-2 rounded"
                  value={serachPram?.userId}
                  onChange={(e) =>
                    setSerachPram({ ...serachPram, userId: e.target.value })
                  }
                >
                  <option value="" disabled selected>
                    Search By User
                  </option>
                  {userslist.map((user, index) => (
                    <option key={index} value={user._id}>
                      {user.name}
                    </option>
                  ))}
                </select>

                <select
                  className="border p-2 rounded"
                  value={serachPram?.policyType}
                  onChange={(e) =>
                    setSerachPram({ ...serachPram, policyType: e.target.value })
                  }
                >
                  <option value="" disabled selected>
                    Policy Type
                  </option>
                  <option value="Own Damaged">Own Damaged</option>
                  <option value="Comprehensive">Comprehensive</option>
                  <option value="Third Party">Third Party</option>
                </select>

                <select
                  className="border p-2 rounded"
                  value={serachPram?.fuelType}
                  onChange={(e) =>
                    setSerachPram({ ...serachPram, fuelType: e.target.value })
                  }
                >
                  <option value="" disabled selected>
                    Fuel Type
                  </option>
                  <option value="CNG">CNG</option>
                  <option value="Petrol">Petrol</option>
                  <option value="Diesel">Diesel</option>
                  <option value="Electric">Electric</option>
                </select>
                <select
                  className="border p-2 rounded"
                  onChange={(e) =>
                    setSerachPram({
                      ...serachPram,
                      commented: e.target.value === "true",
                    })
                  }
                >
                  <option value="" disabled selected>
                    Commented
                  </option>
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </select>
                <div>
                  <DatePicker
                    selected={serachPram?.startDate}
                    onChange={(update) => {
                      setSerachPram({
                        ...serachPram,
                        startDate: update[0],
                        endDate: update[1],
                      });
                    }}
                    startDate={serachPram?.startDate}
                    endDate={serachPram?.endDate}
                    selectsRange
                    placeholderText="Start Date - End Date"
                    className="border p-2 rounded w-[11rem] placeholder-[black]"
                  />
                </div>
                <select
                  className="border p-2 rounded"
                  value={serachPram?.userId}
                  onChange={(e) =>
                    setSerachPram({ ...serachPram, userId: e.target.value })
                  }
                >
                  <option value="" disabled selected>
                    Search By Employee
                  </option>
                  {employee.map((user, index) => (
                    <option key={index} value={user._id}>
                      {user.name}
                    </option>
                  ))}
                </select>

                <button
                  type="button"
                  placeholder="Search Here..."
                  className="border p-2 left-4 rounded bg-[#1D90FE] text-[white]"
                  onClick={() => {
                    onSerach();
                  }}
                >
                  {" "}
                  Serach
                </button>

                <div className="col-span-1 flex gap-2">
                  <button
                    onClick={() => {
                      dispatch(getAllRequestList());
                      setSerachPram({
                        vehicleType: "",
                        requestType: "",
                        userId: "",
                        fuelType: "",
                        policyType: "",
                        commented: false,
                      });
                    }}
                    className="bg-[white] px-4 py-2 rounded border-2 border-[#1E90FE] hover:bg-[#1D90FE] hover:text-[white]"
                  >
                    Reset
                  </button>
                </div>
              </div>

              {/* Cards Section */}
              <div className="grid grid-cols-3 gap-4">
                {allRequestList.map((item, index) => (
                  <div
                    key={index}
                    className="p-4 transition bg-white border rounded shadow-md"
                  >
                    <div className="flex items-center justify-between gap-4 mb-4">
                      {/* Left Section: Image and Name */}
                      <div className="flex items-center gap-4">
                        <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center">
                          <img
                            src={
                              item?.vehicleType === "Bike"
                                ? BicycleImage
                                : item?.vehicleType === "Car"
                                ? Commercial
                                : TruckImage
                            }
                            alt={item.vehicle}
                            className="w-10 h-10 object-contain"
                          />
                        </div>
                        <h2 className="text-lg font-semibold">
                          {item?.ownerDetail?.ownerName}
                        </h2>
                      </div>

                      <div className="relative">
                        <button onClick={() => handleDelete(item._id)}>
                          <Del />
                        </button>
                        <br />
                        <button onClick={() => openModal(item)}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-eye ml-1"
                            viewBox="0 0 16 16"
                          >
                            <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                            <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                          </svg>
                        </button>

                        {visibleTooltipId === item._id && (
                          <div className="absolute top-6 right-0 bg-white shadow-lg border rounded p-2 flex flex-col items-center space-y-2">
                            <p className="text-sm">Are you sure?</p>
                            <div className="flex gap-2">
                              <button
                                onClick={() => confirmDelete(item.id)}
                                className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                              >
                                Yes
                              </button>
                              <button
                                onClick={() => setVisibleTooltipId(null)}
                                className="bg-gray-300 px-3 py-1 rounded hover:bg-gray-400"
                              >
                                No
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <p className="text-gray-700">{item?.vehicleModel}</p>
                    <p className="text-blue-500 font-bold">
                      {item.vehicleType}
                    </p>
                    <p className="text-gray-500">
                      Policy Type: {item.policyType}
                    </p>

                    <div className="relative w-full">
                      {/* New Badge */}
                      {item?.review ? (
                        <span className="absolute top-2 right-4 bg-red-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full shadow-md">
                          Renew
                        </span>
                      ) : (
                        ""
                      )}

                      {/* View Button with White Border */}
                      <button
                        onClick={() => getSpecificRequest(item._id)}
                        className="mt-4 w-full bg-[#1D90FE] text-white py-1 rounded-lg border border-white"
                      >
                        View
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <>
              <div class="bg-white shadow-md rounded-lg p-6 w-full max-w-2xl mx-auto space-y-4">
                <div class="flex items-center justify-between">
                  <div class="flex items-center space-x-2">
                    <div class="bg-blue-100 p-2 rounded-full">
                      {requestById?.userDetails?.length >= 0 ? (
                        <>
                          {" "}
                          {requestById?.userDetails[0]?.profilePhoto ? (
                            <img
                              src={requestById?.userDetails[0]?.profilePhoto}
                              alt="User Avatar"
                              class="w-8 h-8 rounded-full"
                            />
                          ) : (
                            ""
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                    <p class="text-sm font-semibold text-gray-700">
                      {Array.isArray(requestById?.userDetails) &&
                      requestById.userDetails.length > 0
                        ? requestById.userDetails[0]?.name ?? ""
                        : ""}

                      <br />
                      <small class="text-sm font-semibold text-gray-700">
                        {Array.isArray(requestById?.userDetails) &&
                        requestById.userDetails.length > 0
                          ? requestById.userDetails[0]?.email ?? ""
                          : ""}
                      </small>
                    </p>
                  </div>

                  <button
                    onClick={() =>
                      setCommentId({
                        requestId: requestById?._id,
                        userId: requestById?.userId,
                      })
                    }
                    class="text-blue-500 font-semibold hover:underline"
                  >
                    Add Comment +
                  </button>
                </div>

                <h2 class="text-xl font-bold text-gray-800">
                  {requestById?.vehicleModel}
                </h2>

                <div class="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 text-sm text-gray-700">
                  <p>
                    <span class="font-semibold">Type of Policy want:</span>
                    <br />
                    <span class="text-blue-500">{requestById?.policyType}</span>
                  </p>
                  <p>
                    <span class="font-semibold">Made:</span>
                    <br />
                    <span class="text-blue-500">{requestById?.make}</span>
                  </p>
                  <p>
                    <span class="font-semibold">Vehicle Type:</span> <br />
                    <span class="text-blue-500">
                      {requestById?.vehicleType}
                    </span>
                  </p>
                  <p>
                    <span class="font-semibold">Register Number:</span>
                    <br />
                    <span class="text-blue-500">
                      {requestById?.registerNumber}
                    </span>
                  </p>
                  {requestById?.previousPolicytype ? (
                    <p>
                      <span class="font-semibold">Previous Policy Type:</span>
                      <br />
                      <span class="text-blue-500">
                        {requestById?.previousPolicytype}
                      </span>
                    </p>
                  ) : (
                    ""
                  )}

                  {requestById?.previousYearclame ? (
                    <p>
                      <span class="font-semibold">
                        Made any claim in previous year:
                      </span>{" "}
                      <br />
                      <a href="#" class="text-blue-500 hover:underline">
                        {requestById?.previousYearclame}
                      </a>
                    </p>
                  ) : (
                    <p>
                      <span class="font-semibold">
                        Previous Policies Expired More than 90 Days Ago:
                      </span>
                      <br />
                      <a href="#" class="text-blue-500 hover:underline">
                        {requestById?.policyMorethan90 ? "Yes" : "No"}
                      </a>
                    </p>
                  )}

                  <p>
                    <span class="font-semibold">
                      Vehicle Registration Date:
                    </span>
                    <br />
                    <span className="text-blue-500">
                      {(() => {
                        const registrationDate = new Date(
                          requestById?.registrationDate
                        );
                        registrationDate.setMonth(
                          registrationDate.getMonth() - 1
                        );
                        return registrationDate.toISOString().split("T")[0];
                      })()}
                    </span>
                  </p>

                  <p>
                    <span class="font-semibold">
                      Previous Policy Expiry Date:
                    </span>
                    <br />
                    <span class="text-blue-500">
                      {requestById?.policyExpirydate}
                    </span>
                  </p>

                  <div className="inline-flex items-center gap-20">
                    <div className="flex flex-col items-center gap-2">
                      <span
                        className="font-semibold"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        Vehicle Detail
                      </span>
                      <button
                        className="bg-blue-500 text-white font-semibold px-4 py-1 rounded mt-2"
                        onClick={() => {
                          fetch(requestById?.vehicleDetailURL)
                            .then((response) => response.blob())
                            .then((blob) => {
                              const link = document.createElement("a");
                              link.href = URL.createObjectURL(blob); // Convert the Blob to a downloadable URL
                              link.download = "vehicle_detail.png"; // Provide a default filename for the download
                              document.body.appendChild(link);
                              link.click(); // Trigger the download
                              document.body.removeChild(link); // Clean up
                            })
                            .catch((error) =>
                              console.error("Download error:", error)
                            ); // Catch any errors
                        }}
                      >
                        Download
                      </button>
                    </div>

                    {/* Previous Policy Button */}
                    {requestById?.previousPolicyURL ? (
                      <div className="flex flex-col items-center gap-2">
                        <span className="font-semibold">Previous Policy</span>
                        <button
                          className="bg-blue-500 text-white font-semibold px-4 py-1 rounded mt-2"
                          onClick={() => {
                            fetch(requestById?.previousPolicyURL)
                              .then((response) => response.blob())
                              .then((blob) => {
                                const link = document.createElement("a");
                                link.href = URL.createObjectURL(blob); // Convert the Blob to a downloadable URL
                                link.download = "Previous_Policy.png"; // Provide a default filename for the download
                                document.body.appendChild(link);
                                link.click(); // Trigger the download
                                document.body.removeChild(link); // Clean up
                              })
                              .catch((error) =>
                                console.error("Download error:", error)
                              ); // Catch any errors
                          }}
                        >
                          Download
                        </button>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <h2 class="text-xl font-bold text-gray-800">Owner Detail</h2>

                <div class="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 text-sm text-gray-700">
                  <p>
                    <span class="font-semibold">Owner Name:</span>
                    <br />
                    <span class="text-blue-500">
                      {requestById?.ownerDetail?.ownerName}
                    </span>
                  </p>

                  <p>
                    <span class="font-semibold">Phone:</span>
                    <br />
                    <span class="text-blue-500">
                      {" "}
                      {requestById?.ownerDetail?.ownerPhone}
                    </span>
                  </p>
                  <p>
                    <span class="font-semibold">Address:</span>
                    <br />
                    <span class="text-blue-500">
                      {" "}
                      {requestById?.ownerDetail?.ownerAddress}
                    </span>
                  </p>
                  {requestById?.ownerDetail?.ownerEmail ? (
                    <p>
                      <span class="font-semibold">Email:</span>
                      <br />
                      <span class="text-blue-500">
                        {" "}
                        {requestById?.ownerDetail?.ownerEmail}
                      </span>
                    </p>
                  ) : (
                    ""
                  )}
                </div>

                {requestById?.quotationDetail.length > 0 && (
                  <div className="space-y-4">
                    <div className="flex items-center justify-between mb-4">
                      <h2 className="text-xl font-bold text-gray-800">
                        Quotations Detail
                      </h2>
                      <strong
                        onClick={() => {
                          setQuotation(requestById?._id);
                          setQuotationDetail(requestById?.quotationDetail);
                        }}
                        className="text-blue-500 cursor-pointer hover:underline"
                      >
                        Edit
                      </strong>
                    </div>

                    {requestById?.quotationDetail.map((data, index) => (
                      <div key={index} className="flex gap-4 items-start">
                        <div className="flex items-center space-x-2 px-4 py-2 bg-blue-50 rounded-full shadow relative">
                          <img
                            src={data?.companyLogo}
                            alt="Company Logo"
                            className="w-8 h-8 rounded-full overflow-hidden"
                          />
                          <span className="text-black font-semibold">
                            {data?.companyName}, ₹{data?.premiumAmount},{" "}
                            {data?.activityPoints}
                          </span>

                          {requestById?.paymentDetail?.companyName ===
                            data?.companyName && (
                            <span className="absolute top-[-7px] right-0 px-2 text-white text-xs font-bold bg-green-500 rounded-full">
                              Paid
                            </span>
                          )}
                        </div>

                        {requestById?.paymentDetail?.companyName ===
                          data?.companyName && (
                          <div className="flex flex-col items-start space-y-2">
                            <div className="text-xs text-gray-500">
                              {/* Screenshot:{" "}
                              {String(requestById?.paymentScreenShot)} */}
                            </div>
                            <img
                              src={requestById?.paymentScreenShot}
                              alt="Payment Screenshot"
                              width={150}
                              height={150}
                              className="object-cover rounded-lg shadow-md"
                            />
                            <button
                              className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded transition-colors"
                              onClick={() =>
                                downloadImage(requestById?.paymentScreenShot)
                              }
                            >
                              Download Screenshot
                            </button>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}

                {requestById?.paymentDetail.status == "Paid" &&
                requestById?.policyUploaded == false ? (
                  <div className="flex justify-center">
                    <button
                      onClick={() => setUploadPolicy(requestById?._id)}
                      class="bg-blue-500 text-white px-4 py-2 rounded-lg font-semibold hover:bg-blue-600"
                    >
                      Upload Policy
                    </button>
                  </div>
                ) : (
                  ""
                )}

                {requestById?.policyUploaded ? (
                  <>
                    {" "}
                    <h2 class="text-xl font-bold text-gray-800">
                      Uploaded Policy
                    </h2>{" "}
                    <h6
                      className="cursor-pointer flex items-center space-x-2 px-4 py-2 bg-blue-50 rounded-full shadow relative flex items-center justify-center text-center text-blue-500"
                      onClick={() => {
                        fetch(requestById?.policyUrl)
                          .then((response) => response.blob()) // Convert response to a Blob
                          .then((blob) => {
                            const link = document.createElement("a");
                            link.href = URL.createObjectURL(blob); // Create a Blob URL
                            link.download = "policy_file.png"; // Set the default filename
                            document.body.appendChild(link);
                            link.click(); // Trigger the download
                            document.body.removeChild(link); // Clean up
                          })
                          .catch((error) =>
                            console.error("Download error:", error)
                          ); // Handle errors
                      }}
                    >
                      You have uploaded the Policy file{" "}
                      <DownloadIcon className="ml-2" />
                    </h6>
                  </>
                ) : (
                  ""
                )}

                {requestById?.policyUploaded &&
                requestById?.paymentDone &&
                requestById?.paymentVarified == false ? (
                  <>
                    {" "}
                    <h6
                      className="cursor-pointer flex items-center space-x-2 px-4 py-2 bg-blue-50 rounded-full shadow relative flex items-center justify-center text-center text-blue-500"
                      onClick={() => {
                        varifyActivityPoints();
                      }}
                    >
                      <p>Varify</p>{" "}
                      <strong>
                        {requestById?.paymentDetail?.activityPointsReceived}
                      </strong>
                      <p> Activity Points for that request </p>
                    </h6>
                  </>
                ) : (
                  ""
                )}

                {requestById?.paymentVarified == true ? (
                  <h6 className="cursor-pointer flex items-center space-x-2 px-4 py-2 bg-[#22C55E] rounded-full shadow relative flex items-center justify-center text-center text-[white]">
                    <p>You Varified</p>{" "}
                    <strong>
                      {requestById?.paymentDetail?.activityPointsReceived}
                    </strong>{" "}
                    <p>Activity Points for that request</p>{" "}
                  </h6>
                ) : (
                  ""
                )}

                {requestById?.quotationDetail.length == 0 ? (
                  <div className="flex justify-center">
                    <button
                      onClick={() => setQuotation(requestById?._id)}
                      class="bg-blue-500 text-white px-4 py-2 rounded-lg font-semibold hover:bg-blue-600"
                    >
                      Add Quotation
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </>
          )}
          {isObject ? (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
              {/* Modal Container */}
              <div className="bg-white p-6 rounded-lg shadow-xl w-1/3 max-w-md">
                {/* Title */}
                <h2 className="text-lg font-semibold text-gray-700 mb-4">
                  Progress Status
                </h2>

                {/* Status Items */}
                <div className="flex flex-wrap gap-2">
                  {[
                    { key: "requestSent", label: "Request Sent" },
                    {
                      key: "quotationMade",
                      label: "Quotation Made",
                    },
                    { key: "paymentDone", label: "Payment Done" },
                    {
                      key: "policyUploaded",
                      label: "Policy Uploaded",
                    },
                  ]
                    .filter((stage) => isObject[stage?.key])
                    .map((stage, index) => (
                      <span
                        key={index}
                        className="inline-flex items-center bg-green-500 text-white text-sm font-medium px-3 py-1 rounded-full"
                      >
                        ✓ {stage?.label}
                      </span>
                    ))}
                </div>

                {/* Close Button */}
                <button
                  onClick={closeModal}
                  className="mt-4 w-full py-2 bg-red-500 text-white font-semibold rounded-lg hover:bg-red-600 transition duration-300"
                >
                  Close
                </button>
              </div>
            </div>
          ) : (
            ""
          )}

          {quotation && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
              <div
                style={{ width: "40rem", height: "40rem", padding: "3rem" }}
                className="overflow-y-auto scrollbar-hide bg-[white]"
              >
                <div className="bg-white  rounded-lg   p-3 ">
                  <div className="flex items-center justify-between mb-4">
                    {/* Title */}
                    <h2 className="text-xl font-bold">Add Quotation</h2>

                    {/* Icon */}
                    <FaTimes
                      size={20}
                      className="text-[#EF508D] cursor-pointer"
                      onClick={() => {
                        setQuotation(null);
                        setQuotationDetail([
                          {
                            companyName: "",
                            coverAmount: "",
                            cashlessCharge: "",
                            activityPoints: 0,
                            companyLogo: "",
                            premiumAmount: "",
                            paymentLink: "",
                          },
                        ]);
                      }}
                    />
                  </div>

                  {quotationDetail.map((form, index) => (
                    <div key={index} className="border p-4 mb-4 rounded">
                      <span className="m-4 flex items-center gap-4">
                        <h3 className="text-lg font-semibold">
                          Quotation #{index + 1}
                        </h3>
                        {form.companyLogo && (
                          <div className="text-center">
                            <img
                              src={form.companyLogo}
                              className="rounded-full border border-gray-300 shadow-md"
                              width={100}
                              height={100}
                              alt="Company Logo"
                            />
                          </div>
                        )}
                      </span>

                      <select
                        className="w-full p-2 border border-gray-300 rounded"
                        value={form.companyName}
                        onChange={(e) =>
                          handleInputChange(
                            index,
                            "companyName",
                            e.target.value
                          )
                        }
                      >
                        <option value="">Company Name</option>
                        {companyList.map((company) => (
                          <option key={company._id} value={company.companyName}>
                            {company.companyName}
                          </option>
                        ))}
                      </select>
                      <div className="mb-2 mt-2">
                        <input
                          type="text"
                          placeholder=" Cover amount (IDV)"
                          className="w-full p-2 border border-gray-300 rounded"
                          value={form.coverAmount}
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "coverAmount",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="mb-2">
                        <input
                          type="text"
                          className="w-full p-2 border border-gray-300 rounded"
                          placeholder="Payment Link"
                          value={form.paymentLink}
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "paymentLink",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="mb-2">
                        <input
                          type="text"
                          placeholder="Premium Amount"
                          className="w-full p-2 border border-gray-300 rounded"
                          value={form.premiumAmount}
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "premiumAmount",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="mb-2">
                        <label className="block text-gray-700"></label>
                        <input
                          type="text"
                          placeholder="Cashless Garages"
                          className="w-full p-2 border border-gray-300 rounded"
                          value={form.cashlessCharge}
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "cashlessCharge",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="mb-2">
                        <input
                          type="number"
                          placeholder="Activity Points"
                          className="w-full p-2 border border-gray-300 rounded"
                          value={form.activityPoints}
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "activityPoints",
                              e.target.value
                            )
                          }
                        />
                      </div>

                      {quotationDetail.length > 1 && (
                        <button
                          className="text-red-500 underline mt-2"
                          onClick={() => removeForm(index)}
                        >
                          Remove Quotation
                        </button>
                      )}
                    </div>
                  ))}
                  <div className="flex justify-between">
                    {quotationDetail.length >= 3 ? (
                      ""
                    ) : (
                      <motion.button
                        className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400 transition-all"
                        onClick={addForm}
                        whileHover={{ scale: 1.05 }} // Scale effect on hover
                        whileTap={{ scale: 0.95 }} // Slightly shrink when clicked
                        initial={{ opacity: 0 }} // Start with opacity 0
                        animate={{ opacity: 1 }} // Fade in animation
                        transition={{ duration: 0.3 }} // Set duration for animation
                      >
                        Add +
                      </motion.button>
                    )}

                    <motion.button
                      className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 transition-all"
                      onClick={handleSubmit}
                      whileHover={{ scale: 1.05 }} // Scale effect on hover
                      whileTap={{ scale: 0.95 }} // Slightly shrink when clicked
                      initial={{ opacity: 0 }} // Start with opacity 0
                      animate={{ opacity: 1 }} // Fade in animation
                      transition={{ duration: 0.3 }} // Set duration for animation
                    >
                      Submit Quotations
                    </motion.button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {uploadPolicy && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white p-6 rounded-lg shadow-lg w-1/3">
                <h2 className="text-xl font-bold mb-4">Upload Policy</h2>
                <div className="mb-4">
                  <div>
                    <label>Policy File</label>

                    <input
                      type="file"
                      accept=".jpg, .jpeg, .png"
                      className="w-full p-2 border border-gray-300 rounded"
                      onChange={(e) => onChangeUpload(e)}
                    />
                    <label>Expire After</label>
                    <input
                      type="date"
                      className="w-full p-2 border border-gray-300 rounded"
                      onChange={(e) => setPolicyExpire(e.target.value)}
                    />
                  </div>
                </div>
                <div className="flex justify-center  space-x-2">
                  <button
                    className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition-all"
                    onClick={() => setUploadPolicy(false)} // Hides the popup on cancel
                  >
                    Cancel
                  </button>
                  <button
                    className="px-4 py-2 bg-blue-500 text-white rounded"
                    onClick={() => uploadRequestPolicy()}
                  >
                    Upload Now
                  </button>
                </div>
                <div className="flex justify-end"></div>
              </div>
            </div>
          )}
          {commentId && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white p-6 rounded-lg shadow-lg w-1/3">
                <h2 className="text-xl font-bold mb-4">Add Comment</h2>
                <div className="mb-4">
                  <input
                    type="text"
                    className="w-full p-2 border border-gray-300 rounded"
                    onChange={(e) => {
                      setComment(e.target.value);
                    }}
                  />
                </div>

                <div className="flex  gap-2 mt-4">
                  <button
                    onClick={() => setCommentId(null)} // This cancels the pop-up
                    className="px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400"
                  >
                    Cancel
                  </button>
                  <button
                    className="px-4 py-2 bg-blue-500 text-white rounded"
                    onClick={() => addRequestComment()}
                  >
                    Add Commnt
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Circles height="40" width="40" color="#1E90FF" ariaLabel="loading" />
        </div>
      )}
    </>
  );
};

export default Request;
